// 中文翻译表(所有 UI 文案的唯一来源)
const zh = {
  // ===== 公共 =====
  '公共.保存': '保存',
  '公共.取消': '取消',
  '公共.删除': '删除',
  '公共.编辑': '编辑',
  '公共.刷新': '刷新',
  '公共.确认': '确认',
  '公共.加载中': '加载中…',
  '公共.暂无数据': '暂无数据',
  '公共.操作': '操作',
  '公共.是': '是',
  '公共.否': '否',
  '公共.下一步': '下一步 →',
  '公共.上一步': '← 上一步',
  '公共.复制': '复制',
  '公共.已复制': '✓ 已复制',
  '公共.退出': '退出',
  '公共.请先输入Key': '请先输入 API Key',
  '公共.格式错误': '格式可能有误',
  '公共.查询失败': '查询失败',
  '公共.兑换': '兑换',
  '公共.立即兑换': '立即兑换',
  '公共.兑换码': '兑换码',

  // ===== 导航栏 =====
  '导航.用户面板': '用户面板',
  '导航.管理后台': '管理后台',
  '导航.接入指南': '接入指南',
  '导航.公告': '公告',
  '导航.网关总览': '网关总览',
  '导航.渠道管理': '渠道管理',
  '导航.令牌管理': '令牌管理',
  '导航.套餐管理': '套餐管理',
  '导航.系统设置': '系统设置',
  '导航.修改密码': '修改密码',
  '导航.联系客服': '联系客服',

  // ===== 首页:4 格卡 =====
  '首页.累计消耗': '累计消耗',
  '首页.累计消耗说明': '已消耗次数 / 套餐总次数(无限时显示 ∞)',
  '首页.5小时消耗': '5 小时消耗',
  '首页.5小时说明': '最近 5 小时内按模型倍率累计消耗的次数',
  '首页.本周消耗': '本周消耗',
  '首页.本周说明': '本周一以来按模型倍率累计消耗的次数',
  '首页.网关状态': '网关状态',
  '首页.无限': '无限',
  '首页.次': '次',
  '首页.在线': '在线',
  '首页.离线': '离线',
  '首页.未知': '未知',

  // ===== 首页:API Key 卡 =====
  '首页.我的APIKey': '我的 API Key',
  '首页.请输入Key': '请输入 API Key',
  '首页.Key提示': '粘贴 sk- 开头的密钥,系统会校验格式后查询余额',
  '首页.查询': '查询余额',
  '首页.刷新': '刷新',
  '首页.清除': '清除',
  '首页.已选择': '已选',

  // ===== 首页:兑换卡 =====
  '首页.兑换额度': '兑换次数',
  '首页.兑换码': '兑换码',
  '首页.兑换按钮': '立即兑换',
  '首页.兑换说明': '输入兑换码(通常以 R- 开头)给当前账号充值',

  // ===== 首页:接入说明 =====
  '首页.接入说明': '接入说明',
  '首页.BaseURL': 'Base URL',
  '首页.默认模型': '默认模型',
  '首页.请求示例': '请求示例',
  '首页.复制成功': '已复制',
  '首页.OpenAI兼容': 'OpenAI 兼容',
  '首页.Anthropic兼容': 'Anthropic 兼容',

  // ===== 日志/图表 =====
  '日志.ID': 'ID',
  '日志.时间': '时间',
  '日志.模型': '模型',
  '日志.次数': '次数',
  '日志.耗时': '耗时',
  '日志.状态': '状态',
  '日志.成功': '成功',
  '日志.失败': '失败',
  '日志.请求日志': '请求日志',
  '日志.恢复7天': '恢复 7 天',
  '日志.暂无日志': '暂无请求日志',
  '日志.近7天': '过去 7 天调用',
  '日志.无数据': '所选时间范围内无调用数据',
  '图表.区间合计': '区间合计',
  '图表.峰值': '峰值',
  '图表.仅一天': '本次区间内仅这一天有调用',
  'key.天': '天',
  'key.小时': '小时',
  'key.分钟': '分钟',
  'key.创建时间': '创建时间',
  'key.过期时间': '过期时间',
  'key.剩余': '剩余',
  'key.待激活': '待激活',
  'key.永不过期': '永不过期',
  'key.待激活说明': '待激活(首次调用开始计时)',

  // ===== 接入指南 =====
  '指南.标题': '接入指南',
  '指南.介绍': '配置 Base URL 和 API Key 即可使用,无第三方转发。',
  '指南.BaseURL': 'Base URL',
  '指南.APIKey': 'API Key',
  '指南.OpenAI': 'OpenAI 兼容',
  '指南.Anthropic': 'Anthropic 兼容',
  '指南.Curl': 'cURL',
  '指南.Python': 'Python',
  '指南.Node': 'Node.js',
  '指南.复制': '复制',
  '指南.重要提示': '⚠️ 重要提示',
  '指南.重要提示1': '请使用下方生成的配置,确保 API 地址正确指向本服务(工具内置的预设地址不同,会连接失败)',
  '指南.重要提示2': '所选模型上下文长度不同时,一键配置会自动调整参数',
  '指南.步骤1标题': '输入 API Key',
  '指南.步骤1描述': '卡号即为您的 API Key,格式为 sk-xxxxx',
  '指南.步骤2标题': '选择工具',
  '指南.步骤2描述': '选择您要接入的工具',
  '指南.步骤3标题': '选择操作系统',
  '指南.步骤3描述': '适配您的开发环境',
  '指南.步骤4标题': '选择模型',
  '指南.步骤4描述': '选择要使用的模型',
  '指南.步骤5标题': '生成配置',
  '指南.步骤5描述': '一键生成可直接使用的配置',
  '指南.上下文': '上下文',
  '指南.粘贴提示': '请将以上内容粘贴到您的工具配置文件中',
  '指南.售后保障': '售后保障',
  '指南.售后保障1': '所用模型均为官方接口,响应速度与官方一致',
  '指南.售后保障2': '如因我方服务问题导致无法使用,按剩余次数退款',
  '指南.点击复制': '点击复制',
  '指南.支持工具': '支持 Claude Code、OpenCode、OpenClaw 等工具,持续接入中',
  '指南.查看指南': '查看接入指南 →',
  '指南.步骤1详细': '卡号即为您的 API Key,格式为',
  '指南.步骤1占位符': '粘贴您的 API Key,如 sk-f47ac10b-...',
  '指南.推荐': '推荐',
  '指南.配置': '配置',
  '指南.联系客服弹窗': '售后支持请联系客服',
  'guide.tool.ccswitch.badge': '推荐 · 一站式配置 Claude Code / OpenClaw / OpenCode',
  'guide.tool.claudecode.badge': 'Anthropic 官方编程助手',
  'guide.tool.openclaw.badge': '能干活的 AI 助手',
  'guide.tool.opencode.badge': '开源 AI 编程助手',
  'guide.tool.curl.badge': '命令行快速测试 API',

  // ===== Admin:令牌管理 =====
  '令牌.页面标题': '令牌管理',
  '令牌.生成': '+ 生成令牌',
  '令牌.导出': '导出未售出 CSV',
  '令牌.批量删除': '批量删除',
  '令牌.标记售出': '标记售出',
  '令牌.已选': '已选 {n} 项',
  '令牌.全部状态': '全部状态',
  '令牌.未售出': '未售出',
  '令牌.已售出': '已售出',
  '令牌.全部套餐': '全部套餐',
  '令牌.未关联套餐': '未关联套餐',
  '令牌.已下架': '已下架',
  '令牌.新键弹窗标题': '请立即复制并保存新令牌',
  '令牌.复制键提示': '密钥仅显示一次,关闭后无法再次查看完整值。',
  '令牌.复制键按钮': '复制密钥',
  '令牌.生成成功': '已生成,密钥已复制',
  '令牌.日志': '日志',
  '令牌.禁用': '禁用',
  '令牌.启用': '启用',

  '令牌.状态.待售': '待售',
  '令牌.状态.待激活': '待激活',
  '令牌.状态.使用中': '使用中',
  '令牌.状态.已禁用': '已禁用',
  '令牌.状态.已过期': '已过期',
  '令牌.状态.已耗尽': '已耗尽',
  '令牌.状态.未关联': '未关联',
  '令牌.状态.套餐已删除': '(套餐已删除)',

  // ===== Admin:套餐 =====
  '套餐.页面标题': '套餐管理',
  '套餐.新建': '+ 新建套餐',
  '套餐.名称': '名称',
  '套餐.次数': '次数',
  '套餐.5h限额': '5h 限额',
  '套餐.周限额': '周限额',
  '套餐.价格': '价格',
  '套餐.启用': '启用',

  // ===== Admin: 虚拟用户管理(历史遗留,现在已无 UI 调用方,保留仅防止意外引用) =====
  // '用户.页面标题': '用户管理',
  // '用户.新建': '+ 添加用户',
  // '用户.用户名': '用户名',
  // '用户.密码': '密码',
  // '用户.额度': '次数',
  // '用户.状态': '状态',

  // ===== Admin:渠道 =====
  '渠道.页面标题': '渠道管理',
  '渠道.新建': '+ 添加渠道',
  '渠道.名称': '名称',
  '渠道.类型': '类型',
  '渠道.BaseURL': 'Base URL',
  '渠道.支持模型': '支持模型',
  '渠道.24h调用': '24h 调用',

  // ===== Admin:设置 =====
  '设置.页面标题': '系统设置',
  '设置.Tab.基本设置': '基本设置',
  '设置.Tab.令牌默认值': '令牌默认值',
  '设置.Tab.对外发卡': '对外发卡',
  '设置.Tab.补货策略': '补货策略',
  '设置.Tab.数据维护': '数据维护',
  '设置.站点名称': '站点名称',
  '设置.副标题': '副标题',
  '设置.公告': '首页公告',
  '设置.对外地址': '对外地址',
  '设置.保存设置': '保存设置',

  // ===== 工单(用户侧) =====
  '工单.按钮': '工单',
  '工单.抽屉标题': '我的工单',
  '工单.提交按钮': '提交工单',
  '工单.空提示': '暂无工单,遇到问题可点上方提交',
  '工单.未读': '● 管理员已回复',
  '工单.未知状态': '未知',
  '工单.消息条数': '{n} 条消息',
  '工单.提交弹窗标题': '提交工单',
  '工单.提交成功': '工单已提交,管理员会尽快回复',
  '工单.提交失败': '提交失败',
  '工单.主题': '主题',
  '工单.主题占位符': '一句话描述您的问题',
  '工单.主题必填': '请输入主题',
  '工单.内容': '问题详情',
  '工单.内容占位符': '请详细描述您遇到的问题',
  '工单.内容必填': '请输入问题描述',
  '工单.详情标题': '工单详情',
  '工单.发送': '发送回复',
  '工单.已关闭': '此工单已关闭,无法继续回复',
  '工单.回复占位符': '输入回复…',
  '工单.回复必填': '请输入回复',
  '工单.已回复': '已回复',
  '工单.回复失败': '回复失败',
  '工单.创建于': '创建于',
  '工单.作者用户': '👤 我',
  '工单.作者管理员': '🛠 管理员',
  '工单.状态.进行中': '进行中',
  '工单.状态.已关闭': '已关闭',

  // ===== 语言切换 =====
  '语言.中文': '中文',
  '语言.英文': 'English',
};

export default zh;